(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2968,5442,7861,4231,7907,1877],{

/***/ 59848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = undefined;

var _classCallCheck2 = __webpack_require__(99663);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22600);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(49135);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(93196);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Container, _React$Component);

  function Container() {
    (0, _classCallCheck3.default)(this, Container);
    return (0, _possibleConstructorReturn3.default)(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  (0, _createClass3.default)(Container, [{
    key: 'getClassName',
    value: function getClassName() {
      var className = ['os_container'];
      className.push('os_container_' + this.props.size);
      if (this.props.className) {
        className.push(this.props.className);
      }

      return className.join(' ');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.getClassName(), style: this.props.style },
        this.props.children
      );
    }
  }]);
  return Container;
}(_react2.default.Component), _class.propTypes = {
  children: _propTypes2.default.any,
  style: _propTypes2.default.object,
  size: _propTypes2.default.string,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  size: 'big',
  style: {},
  className: ''
}, _temp);
exports.Z = Container;

/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 64312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[mobileOrDesktop]/[hostname]/[...slug]",
      function () {
        return __webpack_require__(84057);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79961);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);




function Loading(props) {
    var color = props.color, className = props.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().item), className),
            style: {
                borderColor: color
            }
        })
    });
};


/***/ }),

/***/ 19060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SsgFallback; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69528);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59848);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80805);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);





function SsgFallback() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().loading)
        })
    });
};


/***/ }),

/***/ 25932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTrack; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src638882257_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src638882257_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src638882257_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25074);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50456);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          mutation trackAction(\n            $type: String\n            $productId: ID\n            $orderId: ID\n            $path: String\n            $meta: JSON\n          ) {\n            trackAction(\n              type: $type\n              productId: $productId\n              orderId: $orderId\n              path: $path\n              meta: $meta\n            )\n          }\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function useTrack() {
    var mutate = (0,_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1__.useMutate)();
    var track = function() {
        var _ref = _asyncToGenerator(_codebuild_output_src638882257_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(type, params) {
            return _codebuild_output_src638882257_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_2__["default"])(_templateObject()),
                            variables: _objectSpread({}, params, {
                                type: type
                            })
                        });
                    case 3:
                        _ctx.next = 7;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function track(type, params) {
            return _ref.apply(this, arguments);
        };
    }();
    return track;
};


/***/ }),

/***/ 25442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NoWebsite; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43469);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function NoWebsite(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/no-website.svg",
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().image)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "Este sitio web no est\xe1 configurado correctamente"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "https://getjusto.com",
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().logo),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/logo-dark.svg"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 57907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/componentTypes/index.ts

var ContactForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(1228), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(791), __webpack_require__.e(7502), __webpack_require__.e(4336), __webpack_require__.e(2317), __webpack_require__.e(9925), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(1960)]).then(__webpack_require__.bind(__webpack_require__, 82109));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(82109)
            ];
        }
    }
});
var CoverManager = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4829).then(__webpack_require__.bind(__webpack_require__, 24829));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24829)
            ];
        }
    }
});
var Custom = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4481), __webpack_require__.e(7212)]).then(__webpack_require__.bind(__webpack_require__, 7212));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7212)
            ];
        }
    }
});
var DeliveryZone = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(9563)]).then(__webpack_require__.bind(__webpack_require__, 47266));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47266)
            ];
        }
    }
});
var Faq = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5445), __webpack_require__.e(2933)]).then(__webpack_require__.bind(__webpack_require__, 99654));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99654)
            ];
        }
    }
});
var FeaturedCategories = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(9036)]).then(__webpack_require__.bind(__webpack_require__, 89036));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89036)
            ];
        }
    }
});
var FullImageWithMessage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(2851)]).then(__webpack_require__.bind(__webpack_require__, 55638));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55638)
            ];
        }
    }
});
var Gallery = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(639)]).then(__webpack_require__.bind(__webpack_require__, 20639));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20639)
            ];
        }
    }
});
var Hero = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(9665)]).then(__webpack_require__.bind(__webpack_require__, 9665));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9665)
            ];
        }
    }
});
var ImageWithMessage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(9650)]).then(__webpack_require__.bind(__webpack_require__, 69650));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69650)
            ];
        }
    }
});
var Instagram = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 903).then(__webpack_require__.bind(__webpack_require__, 40903));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40903)
            ];
        }
    }
});
var JustAnImage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(6887)]).then(__webpack_require__.bind(__webpack_require__, 6887));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6887)
            ];
        }
    }
});
var Links = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(8995)]).then(__webpack_require__.bind(__webpack_require__, 62125));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62125)
            ];
        }
    }
});
var MultiImageWithMessage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(5540)]).then(__webpack_require__.bind(__webpack_require__, 55540));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55540)
            ];
        }
    }
});
var Popup = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(5330)]).then(__webpack_require__.bind(__webpack_require__, 31674));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31674)
            ];
        }
    }
});
var ProductShowcase = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(7570)]).then(__webpack_require__.bind(__webpack_require__, 72784));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72784)
            ];
        }
    }
});
var Publications = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 755).then(__webpack_require__.bind(__webpack_require__, 40755));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40755)
            ];
        }
    }
});
var Redirect = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9783).then(__webpack_require__.bind(__webpack_require__, 89783));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89783)
            ];
        }
    }
});
var Referrals = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4646).then(__webpack_require__.bind(__webpack_require__, 74646));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74646)
            ];
        }
    }
});
var Slider = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(615), __webpack_require__.e(9378)]).then(__webpack_require__.bind(__webpack_require__, 69378));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69378)
            ];
        }
    }
});
var StartOrdering = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(1228), __webpack_require__.e(5445), __webpack_require__.e(160), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(791), __webpack_require__.e(7502), __webpack_require__.e(4336), __webpack_require__.e(2317), __webpack_require__.e(9925), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(9435), __webpack_require__.e(972), __webpack_require__.e(4001), __webpack_require__.e(1465)]).then(__webpack_require__.bind(__webpack_require__, 73273));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73273)
            ];
        }
    }
});
var StoreLocator = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(1228), __webpack_require__.e(5445), __webpack_require__.e(5990), __webpack_require__.e(6907), __webpack_require__.e(4053), __webpack_require__.e(6350), __webpack_require__.e(191), __webpack_require__.e(7502), __webpack_require__.e(2317), __webpack_require__.e(9207), __webpack_require__.e(7745)]).then(__webpack_require__.bind(__webpack_require__, 99105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99105)
            ];
        }
    }
});
var Stores = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1228), __webpack_require__.e(5990), __webpack_require__.e(4053), __webpack_require__.e(1452)]).then(__webpack_require__.bind(__webpack_require__, 63661));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63661)
            ];
        }
    }
});
var WhiteSpace = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 213).then(__webpack_require__.bind(__webpack_require__, 70213));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(70213)
            ];
        }
    }
});
/* harmony default export */ var componentTypes = ({
    custom: Custom,
    coverManager: CoverManager,
    justAnImage: JustAnImage,
    gallery: Gallery,
    redirect: Redirect,
    hero: Hero,
    popup: Popup,
    featuredCategories: FeaturedCategories,
    startOrdering: StartOrdering,
    deliveryZone: DeliveryZone,
    slider: Slider,
    imageWithMessage: ImageWithMessage,
    links: Links,
    stores: Stores,
    faq: Faq,
    referrals: Referrals,
    contactForm: ContactForm,
    multiImageWithMessage: MultiImageWithMessage,
    whiteSpace: WhiteSpace,
    publications: Publications,
    instagram: Instagram,
    fullImageWithMessage: FullImageWithMessage,
    productShowcase: ProductShowcase,
    storeLocator: StoreLocator
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/data/fragments/website/pageFragment.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment pageComponents on Page {\n    _id\n    path\n    disabled\n    activeComponents {\n      _id\n      options\n      componentTypeId\n      schedule {\n        isScheduled\n        latestScheduleStatus\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var pageFragment = ((0,lib["default"])(_templateObject()));

// EXTERNAL MODULE: ./src/providers/apollo/getClient.ts
var apollo_getClient = __webpack_require__(98751);
;// CONCATENATED MODULE: ./src/data/queries/page/getWebsitePage.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function getWebsitePage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function getWebsitePage_templateObject() {
    var data = getWebsitePage_taggedTemplateLiteral([
        "\n  query getWebsitePage_cached($pageId: ID, $websiteId: ID) {\n    page(pageId: $pageId, websiteId: $websiteId) {\n      ...pageComponents\n    }\n  }\n  ",
        "\n"
    ]);
    getWebsitePage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var getWebsitePageQuery = (0,lib["default"])(getWebsitePage_templateObject(), pageFragment);
function getWebsitePage(websiteId, pageId) {
    return _getWebsitePage.apply(this, arguments);
};
function _getWebsitePage() {
    _getWebsitePage = _asyncToGenerator(regeneratorRuntime.mark(function _callee(websiteId, pageId) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getClient().query({
                        query: getWebsitePageQuery,
                        variables: {
                            pageId: pageId,
                            websiteId: websiteId
                        }
                    });
                case 2:
                    data = _ctx.sent.data;
                    return _ctx.abrupt("return", data.page);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getWebsitePage.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/hooks/useEffect.ts
var useEffect = __webpack_require__(10338);
// EXTERNAL MODULE: ./src/hooks/useTrack.ts
var useTrack = __webpack_require__(25932);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/index.js
var apollo_hooks_lib = __webpack_require__(25074);
;// CONCATENATED MODULE: ./src/page-components/Page/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}








function Page(props) {
    var page = props.page;
    var _componentIdToSsrProps = props.componentIdToSsrProps, componentIdToSsrProps = _componentIdToSsrProps === void 0 ? {} : _componentIdToSsrProps;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var pageResults = (0,apollo_hooks_lib.useApolloQuery)({
        query: getWebsitePageQuery,
        variables: {
            pageId: props.pageId,
            websiteId: websiteId
        },
        partial: true,
        omit: !!page
    });
    if (pageResults === null || pageResults === void 0 ? void 0 : pageResults.page) {
        page = pageResults.page;
    }
    var track = (0,useTrack/* default */.Z)();
    (0,useEffect/* default */.Z)(function() {
        if (page) {
            track("viewPage", {
                path: page.path
            });
        }
    }, [
        page === null || page === void 0 ? void 0 : page._id
    ]);
    if (!page) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: page.activeComponents.map(function(component) {
            var Component = componentTypes[component.componentTypeId];
            var __id;
            var ssrProps = (__id = componentIdToSsrProps[component._id]) !== null && __id !== void 0 ? __id : {};
            if (!Component) return "Component ".concat(component.componentTypeId, " not found");
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ct-".concat(component.componentTypeId),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _objectSpread({}, component.options, ssrProps, {
                    id: component._id
                }))
            }, component._id);
        })
    });
};


/***/ }),

/***/ 84057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ PagesPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_SsgFallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19060);
/* harmony import */ var _page_components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98998);
/* harmony import */ var _page_components_NoWebsite__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25442);
/* harmony import */ var _page_components_Page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57907);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);






var __N_SSG = true;
function PagesPage(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    if (router.isFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SsgFallback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
    }
    if (!props.website) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_NoWebsite__WEBPACK_IMPORTED_MODULE_3__["default"], {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        initialData: props.initialData,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_page_components_Page__WEBPACK_IMPORTED_MODULE_4__["default"], {
            pageId: props.page._id,
            page: props.page,
            componentIdToSsrProps: props.componentIdToSsrProps
        })
    });
};


/***/ }),

/***/ 98751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getClient; }
/* harmony export */ });
/* harmony import */ var _providers_apollo_getClients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54599);

function getClient() {
    var clientName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "main";
    var clients = (0,_providers_apollo_getClients__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    return clients[clientName];
};


/***/ }),

/***/ 79961:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"_1fDaNhCtjd-FpXakwh9Uf3","newOrionLoading":"_16XzDHOt3VBY5SGGpiZ3ZT"};

/***/ }),

/***/ 80805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2k40sP--bs7-ORleL6riGA","loading":"_2eozYEUmcZzMsjXiI6UIu6"};

/***/ }),

/***/ 43469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3uvgfwBWaWQqFyLab9Dtip","image":"hS9SabcUKdHLsU7xUWYeA","title":"_3zsZZ1G9oclG4rKZNszc97","logo":"_1EDR5Wb9Y0TBlQji0Ya33U"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1470,5328,319,3712,1796,4356,3477,8709,8998,5691,9774,2888,179], function() { return __webpack_exec__(64312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);